<app-fd-unauthenticated-card>
    <div class="content login-height">
        <div class="content__header">
            <img *ngIf="isDarkMode" class="content__img" src="assets/images/Fraud_Deflect_logo2-removebg.png">
            <img *ngIf="!isDarkMode" class="content__img" src="assets/images/fraud_deflect_horizontal.jpg">
            <div class="content__info">
                <h1 class="content__title">{{titleText}}</h1>
                <p class="content__subtitle">{{subTitleText}}</p>
            </div>
        </div>
        <!-- TODO: CHANGE THIS TO FORM ELEMENT AND MODIFY THE FLOW TO FOLLOW THE FORM PATTERN (ACTION) -->
        <div class="content__form">
            @if(!passwordResetSent){
            <mat-form-field appearance="outline" floatLabel="always" class="content__field">
                <mat-label>Email Address</mat-label>
                <input matInput i18n-placeholder placeholder="Enter your Email address" [formControl]="email"
                    name="email">
                @if(email.dirty && email.invalid && email.errors?.['required']){
                <mat-error>Email is required</mat-error>
                }
                @else if (email.dirty && email.invalid && email.errors?.['minlength']) {
                <mat-error>Email should be atleast 3 characters</mat-error>
                }
                @else if (email.dirty && email.invalid && email.errors?.['email']) {
                <mat-error>Email has incorrect format</mat-error>
                }
            </mat-form-field>
            }
            @else {
            <div class="content__fp-icon">
                <svg width="108" height="100" viewBox="0 0 108 100" fill="none">
                    <path
                        d="M19.4958 71.4153L19.6815 72.4316L23.9357 95.691C24.253 97.4197 25.4077 98.8682 27.0149 99.5671C28.622 100.263 30.4756 100.114 31.9477 99.1653C37.8731 95.3433 45.6117 90.272 45.4023 89.9749L19.4958 71.4153ZM4.3395 38.3949C2.02672 39.2829 0.385825 41.3627 0.0583211 43.8172C-0.265805 46.2752 0.777482 48.7095 2.77964 50.1647L24.6987 66.1145L102.553 4.86463L33.7135 72.6814L63.6784 94.4857C65.586 95.8734 68.0439 96.2887 70.3094 95.5999C72.5716 94.9111 74.3745 93.1959 75.1849 90.9811L107.24 3.24737C107.564 2.35598 107.338 1.36 106.662 0.694867C105.987 0.0297029 104.991 -0.179609 104.103 0.161429L4.3395 38.3949Z"
                        fill="#FCC11A" />
                </svg>
            </div>
            <span class="content__fp-text">Haven’t received it yet?</span>
            }
            <button class="content__fp-button" (click)="forgotPassword()" [disabled]="email.invalid" mat-raised-button
                color="primary">{{buttonText}}</button>

            <a class="content__login-link" href="login">Back to Login</a>
        </div>
    </div>
</app-fd-unauthenticated-card>